import { ApiClient } from '@/lib/axios/client';
import type {
  Organization,
  CreateOrganizationDto,
  UpdateOrganizationDto,
  OrganizationFilters,
} from './types';
import type { PaginatedData } from '@/lib/axios/types';
import { Dashboard, ReportFilters } from '@/lib/sdk/reports/types';

const BASE_PATH = '/api/v1/orgs';

export class OrganizationApi {
  /**
   * Get all organizations with optional filtering
   */
  static async getAll(filters?: OrganizationFilters): Promise<PaginatedData<Organization>> {
    return await ApiClient.get<PaginatedData<Organization>>(BASE_PATH, {
      params: filters,
    });
  }

  /**
   * Get a single organization by ID
   */
  static async getById(id: string): Promise<Organization> {
    return await ApiClient.get<Organization>(`${BASE_PATH}/${id}`);
  }

  /**
   * Create a new organization
   */
  static async create(data: CreateOrganizationDto): Promise<Organization> {
    return await ApiClient.post<Organization>(BASE_PATH, data);
  }

  /**
   * Update an existing organization
   */
  static async update(id: string, data: UpdateOrganizationDto): Promise<Organization> {
    return await ApiClient.patch<Organization>(`${BASE_PATH}/${id}`, data);
  }

  /**
   * Delete an organization
   */
  static async delete(id: string): Promise<void> {
    await ApiClient.delete<{ data: void }>(`${BASE_PATH}/${id}`);
  }

  /**
   * Get organization dashboards
   */
  static async getOrgDashboards(orgId: string, filters?: ReportFilters): Promise<PaginatedData<Dashboard>> {
    return await ApiClient.get<PaginatedData<Dashboard>>(`${BASE_PATH}/${orgId}/dashboards`, {
      params: filters
    });
  }
}